import { http } from '@pendo/http';

export async function fetchDomainVerificationRecords (orgId) {
    const result = await http.get(`/api/organization/${orgId}/domains`);

    return result.data;
}

export async function verifyDomain (orgId, targetUrl) {
    try {
        const result = await http.post(`/api/organization/${orgId}/brandkit/verify`, { targetUrl });

        return result.data;
    } catch (error) {
        throw error;
    }
}

export async function addDomain (orgId, targetUrl) {
    try {
        const result = await http.post(`/api/organization/${orgId}/domains`, {
            domain: targetUrl,
            source: 'brandkit',
        });

        return result.data;
    } catch (error) {
        throw error;
    }
}

export async function refreshVerification (orgId, domainId) {
    try {
        const result = await http.post(`/api/organization/${orgId}/domains/${domainId}/verify`);

        return result.data;
    } catch (error) {
        throw error;
    }
}

export async function deleteDomain (orgId, domainId) {
    try {
        await http.delete(`/api/organization/${orgId}/domains/${domainId}`);
    } catch (error) {
        throw error;
    }
}
